import auroraColorPalette from './colors';
import palette from './overrides/pallete';
import typography from './overrides/typography';
import shadows from './overrides/shadows';
import paper from './overrides/paper';
import button from './overrides/button';
import input, { inputAdornment } from './overrides/form/input';
import select from './overrides/form/select';
import { inputLabel, formLabel, formHelperText, formControl } from './overrides/form';
import { tablePagination, dataTable, dataTablePagination } from './overrides/datatable';
import appbar from './overrides/appbar';
import chips from './overrides/chip';
import MDSwitch from './overrides/form/switch';
import expansionPanel from './overrides/expansionPanel';
import dialogTitle from './overrides/dialogTitle';
import { toolbarPicker, clockPicker, clockPickerPointer, dTTabsPicker } from './overrides/pickers';
import tabs from './overrides/tabs';
import snackbarContent from './overrides/snackbarContent';
import linearProgress from './overrides/linearProgress';

const applicationTheme = direction => ({
  direction,
  palette,
  border: `1px solid ${auroraColorPalette.primary.borderColor}`,
  typography: typography(direction),
  rounded: {
    small: '8px',
    medium: '12px',
    big: '20px',
  },
  shadows,
  overrides: {
    MuiPaper: paper,
    MuiButton: button,
    MuiInput: input,
    MuiInputLabel: inputLabel,
    MuiFormLabel: formLabel,
    MuiFormHelperText: formHelperText,
    MuiSelect: select,
    MuiFormControl: formControl,
    MuiInputAdornment: inputAdornment,
    MuiToolbar: {
      root: {
        borderRadius: 8,
      },
    },
    MuiListItemText: {
      root: {
        whiteSpace: 'nowrap',
      },
    },
    MuiLinearProgress: linearProgress,
    MuiPickersToolbar: toolbarPicker,
    MuiPickersClock: clockPicker,
    MuiPickersClockPointer: clockPickerPointer,
    MuiPickerDTTabs: dTTabsPicker,
    MuiExpansionPanel: expansionPanel,
    MuiDialogTitle: dialogTitle,
    MuiSnackbarContent: snackbarContent,
    MuiAppBar: appbar,
    MuiTabs: tabs,
    MuiChip: chips(direction),
    MuiSwitch: MDSwitch,
    MuiTablePagination: tablePagination,
    MUIDataTable: dataTable,
    MUIDataTablePagination: dataTablePagination,
  },
});

export default applicationTheme;
